import BaseSvg, { Props } from '../BaseSvg'

const Reload: React.FC<Props> = (props) => (
  <BaseSvg viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M5.91111 0.5C7.97569 0.5 9.79306 1.57436 10.8502 3.20235L12.6667 1.35714V6.5H7.6L9.62044 4.45103C8.90447 3.11843 7.51181 2.21429 5.91111 2.21429C3.57924 2.21429 1.68889 4.13307 1.68889 6.5C1.68889 8.86693 3.57924 10.7857 5.91111 10.7857C7.29201 10.7857 8.51808 10.1128 9.28844 9.07246L11.2531 9.07206C10.3043 11.0988 8.26889 12.5 5.91111 12.5C2.64649 12.5 0 9.81371 0 6.5C0 3.18629 2.64649 0.5 5.91111 0.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </BaseSvg>
)

export default Reload
